import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, Label, FormGroup, InputGroup, Form, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from "react-select";
import { Link } from "react-router-dom";

const Attestations = () => {
  document.title = "AMAVIE | Application de gestion de Afrika Mobility";
  const [loadingBord, setLoadingBord]=useState(false)
  const [attestations, setAttestations]= useState([])
  const [allZones, setAllZones]= useState([])
  const [zones, setZones]= useState([])
  const [zone, setZone]= useState(null)
  const [countries, setCountries]= useState([])
  const [passport, setPassport]= useState("")
  const [total, setTotal]=useState(0)
  const [totalPage, setTotalPage]= useState(0)
  const [currPage, setCurrPage]= useState(0)
  const [currDate, setCurrDate]= useState(moment().format("YYYY-MM-DD"))
  const [user, setUser]= useState(JSON.parse(localStorage.getItem("authUser")).id)
  const [from, setFrom]= useState(moment().subtract(1, 'month').format("YYYY-MM-DD"))
  const [to, setTo]= useState(moment().format("YYYY-MM-DD"))
  const [currAttestation, setCurrAttestation]= useState(null)
  const [selectedZone, setselectedZone] = useState(null);
  const [selectedCountry, setselectedCountry] = useState(null);
  const [modal_detail_attestation, setmodal_detail_attestation] = useState(false);
  const [modal_payment, setmodal_payment] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [modal_success, setmodal_success] = useState(false);
  const [attestationToPay, setAttestationToPay] = useState(null);
  const [attestationToDelete, setAttestationToDelete] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(null);
  const [paymentMethods] = useState([
    {label: "CASH", value: "CASH"},
    {label: "MOBILE MONEY", value: "MOBILE_MONEY"}
  ]);
  const [modal_phone, setmodal_phone] = useState(false);
  const [payerPhone, setPayerPhone] = useState("");

  const tog_detail_attestation = (data) => {
    setCurrAttestation(data)
    setmodal_detail_attestation(!modal_detail_attestation);
    removeBodyCss();
  };

  const tog_payment = (attestation) => {
    setAttestationToPay(attestation);
    setPaymentMethod(null);
    setPayerPhone("");
    setmodal_payment(!modal_payment);
    removeBodyCss();
  };

  const tog_delete = (attestation) => {
    setAttestationToDelete(attestation);
    setmodal_delete(!modal_delete);
    removeBodyCss();
  };
  const confirmPayment = () => {
    if (!paymentMethod) {
      alert("Veuillez sélectionner une méthode de paiement");
      return;
    }

    if (paymentMethod.value === "MOBILE_MONEY") {
      setmodal_payment(false);
      setmodal_phone(true);
      return;
    }

    setLoadingBord(true);
    const paymentData = {
      attestation: {
        id: attestationToPay.id
      },
      method: paymentMethod.value,
      state: "COMPLETED",
      amount: attestationToPay.type === "STANDARD" ? attestationToPay.tarification.tarif : attestationToPay.tarification.tarif_rcvp
    };

    console.log("Données de paiement:", paymentData);

    fetch(`${url.BACKEND_URL}/payments`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentData)
    })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log("Réponse paiement:", responseJson);
      if (responseJson.id) {
        setPaymentSuccess(responseJson);
        setmodal_payment(false);
        setmodal_success(true);
        setPaymentMethod(null);
        setAttestationToPay(null);
        loadAttestations(0);
      } else {
        alert(responseJson.message || "Erreur lors du paiement");
      }
      setLoadingBord(false);
    })
    .catch((error) => {
      console.error("Erreur paiement:", error);
      alert("Erreur lors du paiement");
      setLoadingBord(false);
    });
  };

  const confirmDelete = () => {
    setLoadingBord(true);

    fetch(`${url.BACKEND_URL}/attestations/${attestationToDelete.id}`, {
      method: 'DELETE',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log("Réponse suppression:", responseJson);
      if (responseJson.status === 200 || responseJson.message) {
        alert("Attestation supprimée avec succès!");
        setmodal_delete(false);
        setAttestationToDelete(null);
        loadAttestations(0);
      } else {
        alert(responseJson.message || "Erreur lors de la suppression");
      }
      setLoadingBord(false);
    })
    .catch((error) => {
      console.error("Erreur suppression:", error);
      alert("Erreur lors de la suppression");
      setLoadingBord(false);
    });
  };

  const confirmMobilePayment = () => {
    if (!payerPhone.trim()) {
      alert("Veuillez entrer le numéro de téléphone du payeur");
      return;
    }
    setmodal_phone(false);
    sendPayment();
  };

  const sendPayment = () => {
    setLoadingBord(true);
    const onlinePaymentData = {
        customerReference: `${payerPhone}__${attestationToPay.reference}`,
        purchaseReference: attestationToPay.id,
        amount: attestationToPay.type === "STANDARD" ? attestationToPay.tarification.tarif : attestationToPay.tarification.tarif_rcvp,
        currency: "XOF",
        paymentMethod: "WAVE",
        payerInfo: {
          firstName: attestationToPay.beneficiaries[0]?.first_name || 'Utilisateur',
          lastName: attestationToPay.beneficiaries[0]?.last_name || 'Utilisateur',
          email: attestationToPay.beneficiaries[0]?.email || `${attestationToPay.beneficiaries[0]?.phone}@temp.ci`,
          phone: attestationToPay.beneficiaries[0]?.phone || '00000001'
        }
    };
    fetch(`${url.PAYMENT_API_URL}/payments`, 
      {method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Source-System': 'WEB_APP', 'Payment-Channel': 'AMAVIE_AGENCE_WEB'},
      body: JSON.stringify(onlinePaymentData) })
    .then((response) => response.json())
    .then((responseJson) => {
      setLoadingBord(false);
      if (responseJson.paymentUrl) {
        window.location.href = responseJson.paymentUrl;
      } else {
        alert(responseJson.message || "Erreur lors du paiement Mobile Money");
      }
    })
    .catch(() => {
      alert("Erreur lors du paiement Mobile Money");
      setLoadingBord(false);
    });
  };

  function removeBodyCss() { document.body.classList.add("no_padding")}
  //const handleSelectGroup=(selectedGroup)=> { setselectedGroup(selectedGroup); }
  const handleZone=(event)=> { 
    setselectedZone(event); 
    const getZone = allZones.find(zone => zone.id === event.value);
    const pays = getZone ? getZone.countries : [];
    console.log(getZone);
    
    let countryArray= [{label: "Tout pays", value: ''}];
    countryArray=[...countryArray, ...pays.map(item=>({ label: item.name, value: item.id }))]
    setCountries(countryArray); 
  }
  const handleSelectCountry=(event)=> { setselectedCountry(event); }
  
  const exportAttestations = () => {
    fetch(`${url.BACKEND_URL}/attestations/export?start=${from}&end=${to}
      &zone=${selectedZone ? selectedZone.value:0}
      &destination=${selectedCountry ? selectedCountry.value:0}&passport=${passport}`, { method: 'GET'})
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `attestations_${from}_${to}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
    };

  const loadAttestations=(page)=> {
    setLoadingBord(true)
    fetch(url.BACKEND_URL+"/attestations?start="+from+"&end="+to+"&page="+page+"&size=20"+
      (user!=null ? "&user="+user: "")+
      (selectedZone!=null ? "&zone="+selectedZone.value: "")+
      (selectedCountry!=null ? "&destination="+selectedCountry.value: "")+
      (passport!=null ? "&passport="+passport: ""), {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      console.log(responseJson);
      
      if (responseJson.status==200) { 
        setAttestations(responseJson.data)
        // setTotal(responseJson.data.total)
        // setTotalPage(responseJson.data.total_pages, 30)
        // setCurrPage(responseJson.page, 30)
        setLoadingBord(false)
    } else { setAttestations([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  const loadZones=()=> {
    setLoadingBord(true)
    let zonesArray= [{label: "Toutes zones", value: ''}];
    fetch(url.BACKEND_URL+"/zones", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      setAllZones(responseJson.data)
      if (responseJson.status==200) {
         zonesArray=[
          ...zonesArray,
          ...responseJson.data.map(item=>({
          label: item.name,
          value: item.id
        }))];
        setZones(zonesArray)
        setLoadingBord(false)
    } else { setZones([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };


  useEffect(()=>{ loadAttestations(0); loadZones() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Attestations" />
          <Row>
            <Col xl={9}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">Gestion des attestations</CardTitle>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3}>
              <Card>
                <CardBody>
                    <Link to="/addattestation" color="primary" className="form-control btn btn-primary waves-effect"><i className="fas fa-file"></i> Créer une attestation</Link>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <FormGroup className="form-group mb-3">
                <Label>à partir de</Label>
                <InputGroup className="">
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Date de début"
                    value={from}
                    options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                    onChange={(date, dateStr) => { setFrom(dateStr);}}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup className="form-group mb-3">
                <Label>à</Label>
                <InputGroup className="">
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Date de fin"
                    value={to}
                    options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                    onChange={(date, dateStr) => {setTo(dateStr);}}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label>Zone</Label>
                <Select
                  value={selectedZone}
                  onChange={handleZone}
                  options={zones}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label>Destination</Label>
                <Select
                  value={selectedCountry}
                  onChange={() => {handleSelectCountry();}}
                  options={countries}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label>Num. Passport</Label>
                <input className="form-control" placeholder="Passe port client" onChange={(event)=>setPassport(event.target.value)} type="text" defaultValue="" id="example-datetime-local-input"/>
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Button color="success" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>exportAttestations()}><i className="fas fa-file-excel"></i> Exporter</Button>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadAttestations(0)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {/* <p className="card-title-desc">
                    Use one of two modifier className to make{" "}
                    <code>&lt;thead&gt;</code>s appear light or dark gray.
                  </p> */}
                {/*MODAL POUR CONFIRMER LA SUPPRESSION*/}
                <Modal isOpen={modal_delete} toggle={()=>setmodal_delete(!modal_delete)} centered>
                  <ModalHeader className="mt-0" toggle={()=>setmodal_delete(!modal_delete)}>Confirmer la suppression</ModalHeader>
                  <ModalBody>
                    <div className="mb-3">
                      <div className="text-center mb-4">
                        <i className="fas fa-exclamation-triangle text-warning" style={{fontSize: '48px'}}></i>
                      </div>
                      <h5 className="text-center">Êtes-vous sûr de vouloir supprimer cette attestation ?</h5>
                      <div className="mt-3">
                        <p><strong>Attestation:</strong> {attestationToDelete?.reference}</p>
                        <p><strong>Client:</strong> {attestationToDelete?.beneficiaries?.[0]?.first_name} {attestationToDelete?.beneficiaries?.[0]?.last_name}</p>
                        <p><strong>Montant:</strong> {(attestationToDelete?.type === "STANDARD" ? attestationToDelete?.tarification?.tarif : attestationToDelete?.tarification?.tarif_rcvp)?.toLocaleString('fr-FR')} FCFA</p>
                      </div>
                      <p className="text-danger text-center mt-3"><strong>Cette action est irréversible!</strong></p>
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                      <Button color="secondary" onClick={()=>setmodal_delete(false)}>
                        Annuler
                      </Button>
                      <Button color="danger" onClick={confirmDelete} disabled={loadingBord}>
                        {loadingBord ? "Suppression..." : "Confirmer la suppression"} 
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>

                {/*MODAL POUR CONFIRMER LE PAIEMENT*/}
                <Modal isOpen={modal_payment} toggle={()=>setmodal_payment(!modal_payment)} centered>
                  <ModalHeader className="mt-0" toggle={()=>setmodal_payment(!modal_payment)}>Confirmer le paiement</ModalHeader>
                  <ModalBody>
                    <div className="mb-3">
                      <h5>Attestation: <strong>{attestationToPay?.reference}</strong></h5>
                      <h5>Client: <strong>{attestationToPay?.beneficiaries?.[0]?.first_name} {attestationToPay?.beneficiaries?.[0]?.last_name}</strong></h5>
                      <h5>Montant: <strong className="text-success">{(attestationToPay?.type === "STANDARD" ? attestationToPay?.tarification?.tarif : attestationToPay?.tarification?.tarif_rcvp)?.toLocaleString('fr-FR')} FCFA</strong></h5>
                    </div>
                    <div className="mb-3">
                      <Label>Méthode de paiement</Label>
                      <Select
                        value={paymentMethod}
                        onChange={(selected) => setPaymentMethod(selected)}
                        options={paymentMethods}
                        classNamePrefix="select2-selection"
                        placeholder="Sélectionnez la méthode de paiement"
                      />
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                      <Button color="secondary" onClick={()=>setmodal_payment(false)}>
                        Annuler
                      </Button>
                      <Button color="success" onClick={confirmPayment} disabled={loadingBord}>
                        {loadingBord ? "Traitement..." : "Confirmer le paiement"}
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>

                {/*MODAL POUR LE NUMÉRO DE TÉLÉPHONE MOBILE MONEY*/}
                <Modal isOpen={modal_phone} toggle={()=>{setmodal_phone(false); setmodal_payment(true);}} centered>
                  <ModalHeader className="mt-0" toggle={()=>{setmodal_phone(false); setmodal_payment(true);}}>Numéro Mobile Money</ModalHeader>
                  <ModalBody>
                    <div className="mb-3">
                      <h5>Attestation: <strong>{attestationToPay?.reference}</strong></h5>
                      <h5>Montant: <strong className="text-success">{(attestationToPay?.type === "STANDARD" ? attestationToPay?.tarification?.tarif : attestationToPay?.tarification?.tarif_rcvp)?.toLocaleString('fr-FR')} FCFA</strong></h5>
                    </div>
                    <div className="mb-4">
                      <Label>Numéro de téléphone du payeur</Label>
                      <input
                        className="form-control"
                        placeholder="Ex: 0700000000"
                        type="tel"
                        value={payerPhone}
                        onChange={(e) => setPayerPhone(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                      <Button color="secondary" onClick={()=>{setmodal_phone(false); setmodal_payment(true);}}>
                        Retour
                      </Button>
                      <Button color="success" onClick={confirmMobilePayment} disabled={loadingBord}>
                        {loadingBord ? "Traitement..." : "Confirmer le paiement"}
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>

                {/*MODAL DE SUCCÈS DU PAIEMENT*/}
                <Modal isOpen={modal_success} toggle={()=>setmodal_success(!modal_success)} centered>
                  <ModalHeader className="mt-0" toggle={()=>setmodal_success(!modal_success)}>Paiement réussi</ModalHeader>
                  <ModalBody>
                    <div className="text-center mb-4">
                      <i className="fas fa-check-circle text-success" style={{fontSize: '64px'}}></i>
                    </div>
                    <h4 className="text-center text-success mb-4">Paiement effectué avec succès !</h4>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-2">
                        <span>Référence:</span>
                        <strong>{paymentSuccess?.reference}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Montant:</span>
                        <strong className="text-success">{paymentSuccess?.amount?.toLocaleString('fr-FR')} FCFA</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Méthode:</span>
                        <strong>{paymentSuccess?.method}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Statut:</span>
                        <strong className="text-success">{paymentSuccess?.state}</strong>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                      <Button color="success" onClick={()=>setmodal_success(false)}>
                        Fermer
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>
                
                {/*MODAL POUR VISUALISER L'ATTESTATION*/}
                <Modal isOpen={modal_detail_attestation} toggle={tog_detail_attestation} size="xl">
                  <ModalHeader className="mt-0" toggle={tog_detail_attestation}>Détail attestation</ModalHeader>
                  <ModalBody>

                    <Table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>Num. Attest.</td>
                          <td><strong>{currAttestation?.reference}</strong></td>
                          <td>Zone</td>
                          <td><strong>{currAttestation?.zone?.name}</strong></td>
                          <td>Destination</td>
                          <td><strong>{currAttestation?.destination?.name}</strong></td>
                        </tr>
                        <tr>
                          <td>Du</td>
                          <td><strong>{moment(currAttestation?.startform).format("DD-MM-YYYY")}</strong></td>
                          <td>Jusqu'au</td>
                          <td><strong>{moment(currAttestation?.to).format("DD-MM-YYYY")}</strong></td>
                          <td>Durée</td>
                          <td><strong>{currAttestation?.period} Jours</strong></td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <td className="bg-primary" colSpan={6} style={{ color: "white" }}>Bénéfificaire(s)</td>
                        </tr>
                      </tbody>
                        {currAttestation?.beneficiaries?.map((item, key)=>(
                          <tbody>
                            <tr>
                              <td>Genre: <br/> <strong>{item?.gender}</strong></td>
                              <td>Passeport: <br/> <strong>{item?.passport_number}</strong></td>
                              <td>Expire le: <br/><strong>{moment(item?.passport_expire).format("DD-MM-YYYY")}</strong></td>
                              <td>Nom et prénom: <br/><strong>{item?.first_name} {item?.last_name}</strong></td>
                              <td>Contact: <br/><strong>{item?.phone}</strong></td>
                              <td>Né le: <br/> <strong>{moment(item?.birth_date).format("DD-MM-YYYY")}</strong></td>
                            </tr>
                          </tbody>
                        ))}
                       <tbody>
                        <tr>
                          <td className="bg-primary" colSpan={6} style={{ color: "white" }}>Documents à télécharger</td>
                        </tr>
                      </tbody>
                      <tbody>
                        {currAttestation?.documents?.map((item, key)=>(
                            <tr>
                              <td colSpan={6} style={{ cursor: "pointer" }}><a href={`${url.BACKEND_URL}/files/${item.name}`} target="_blank"><i className="fas fa-file-pdf"></i> {item?.name}</a></td>
                            </tr>
                        ))}
                      </tbody>
                    </Table>
                  </ModalBody>
                  </Modal>
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Client</th>
                          <th>Contact</th>
                          <th>Num. attest.</th>
                          <th>Zone</th>
                          <th>Destination</th>
                          <th>Montant</th>
                          <th colSpan={3}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                         {attestations.map((item, key)=>(
                            <tr>
                              <td>{moment(item.created_date).format("DD-MM-YYYY")}</td>
                              <td>{item.beneficiaries[0]?.first_name} {item.beneficiaries[0]?.last_name}</td>
                              <td>{item.beneficiaries[0]?.phone}</td>
                              <td>{item?.reference}</td>
                              <td>{(item?.zone?.name)}</td>
                              <td>{item?.destination?.name}</td>
                              <td>{item?.payed==0 ? 
                              (<strong className="text-danger">{(item?.type === "STANDARD" ? item?.tarification?.tarif : item?.tarification?.tarif_rcvp)?.toLocaleString('fr-FR')} FCFA (Impayé)</strong>):
                              (<strong className="text-success">{(item?.type === "STANDARD" ? item?.tarification?.tarif : item?.tarification?.tarif_rcvp)?.toLocaleString('fr-FR')} FCFA</strong>)
                              }</td>
                              {item?.payed==0 ?
                                (<>
                                <td><Button color="primary" className="btn btn-primary" onClick={()=>navigate(`/updateattestation/${item.reference}`)}><i className="fas fa-edit text-white"></i></Button></td>
                                <td><Button color="success" className="btn btn-success" onClick={()=>tog_payment(item)}><i className="fas fa-money-check-alt text-white"></i></Button></td>
                                <td><Button color="danger" className="btn btn-danger" onClick={()=>tog_delete(item)}><i className="fas fa-times text-white"></i></Button></td></>)
                                :
                                <td colSpan={3}><Button color="primary" className="btn btn-primary" onClick={()=>{setTimeout(() => { tog_detail_attestation(item)}, 400);}}><i className="fas fa-eye text-white"></i></Button></td>
                              }
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Attestations;
